var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "#45BED9",
    fillOpacity: 0.11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9992 44.5717C36.256 44.5717 44.5707 36.2569 44.5707 26.0002C44.5707 15.7434 36.256 7.42871 25.9992 7.42871C15.7425 7.42871 7.42773 15.7434 7.42773 26.0002C7.42773 36.2569 15.7425 44.5717 25.9992 44.5717Z",
    fill: "#45BED9",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 37.1431C32.1543 37.1431 37.1431 32.1543 37.1431 26.0003C37.1431 19.8462 32.1543 14.8574 26.0003 14.8574C19.8462 14.8574 14.8574 19.8462 14.8574 26.0003C14.8574 32.1543 19.8462 37.1431 26.0003 37.1431Z",
    fill: "#8098D7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4fc370f74c28432e1bf55ee55bcdadb3.svg";
export { ForwardRef as ReactComponent };